// extracted by mini-css-extract-plugin
module.exports = {"GlobalNewsPage_byline":"GlobalNewsPage_GlobalNewsPage_byline__ROEXi"};